var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PermissionTree',{key:_vm.permissionTreeKey,attrs:{"tree":_vm.permissionTree},on:{"update":_vm.onPermissionTreeUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }